/**
 * Helpers de UI EUDI Wallet (NIF-960) — copy y estructura alineados a Figma.
 */

import { IOcrAllowedDocs } from '../models/user-identification';

export type EudiDataGroupIcon = 'icon-user' | 'icon-card' | 'icon-home';

/** ¿Hay captura física OCR (DNI / pasaporte / NIE) en la config? */
export function hasPhysicalOcrDocs(allowedDocs?: IOcrAllowedDocs | null): boolean {
	if (!allowedDocs) {
		return false;
	}
	if (Array.isArray(allowedDocs.dni)) {
		return true;
	}
	if (Array.isArray(allowedDocs.passport)) {
		return true;
	}
	return !!allowedDocs.nie;
}

/**
 * Solo EUDI Wallet: flag activo y sin documentos físicos.
 * → entrada directa a pantalla QR / Abrir Wallet (comentario NIF-960).
 */
export function isEudiOnlyOcrConfig(
	config?: {
		eudi_wallet_enabled?: boolean;
		allowed_docs?: IOcrAllowedDocs | null;
	} | null,
): boolean {
	return !!config?.eudi_wallet_enabled && !hasPhysicalOcrDocs(config.allowed_docs);
}

/** Clave i18n locutada al abrir wallet (desktop QR vs móvil deep link). */
export function resolveEudiInstructionKey(isMobile: boolean): string {
	return isMobile ? 'OCR.EUDI.INSTRUCTION_MOBILE' : 'OCR.EUDI.INSTRUCTION_DESKTOP';
}

export interface EudiDataGroup {
	icon: EudiDataGroupIcon;
	titleKey: string;
	detailKey: string;
}

export interface EudiFaqItem {
	id: string;
	questionKey: string;
	answerKey: string;
}

/** Grupos de datos del panel de credencial (desktop QR / móvil). */
export const EUDI_DATA_GROUPS: ReadonlyArray<EudiDataGroup> = [
	{
		icon: 'icon-user',
		titleKey: 'OCR.EUDI.DATA_PERSONAL_TITLE',
		detailKey: 'OCR.EUDI.DATA_PERSONAL_DETAIL',
	},
	{
		icon: 'icon-card',
		titleKey: 'OCR.EUDI.DATA_DOC_TITLE',
		detailKey: 'OCR.EUDI.DATA_DOC_DETAIL',
	},
	{
		icon: 'icon-home',
		titleKey: 'OCR.EUDI.DATA_ADDRESS_TITLE',
		detailKey: 'OCR.EUDI.DATA_ADDRESS_DETAIL',
	},
];

/**
 * FAQ acordeón: en desktop la 1.ª pregunta habla del QR;
 * en móvil, del deep link a la cartera.
 */
export function buildEudiFaqItems(isMobile: boolean): ReadonlyArray<EudiFaqItem> {
	const q1: EudiFaqItem = isMobile
		? {
				id: 'Q1',
				questionKey: 'OCR.EUDI.HELP_Q1_MOBILE',
				answerKey: 'OCR.EUDI.HELP_A1_MOBILE',
			}
		: {
				id: 'Q1',
				questionKey: 'OCR.EUDI.HELP_Q1_DESKTOP',
				answerKey: 'OCR.EUDI.HELP_A1_DESKTOP',
			};

	return [
		q1,
		{ id: 'Q2', questionKey: 'OCR.EUDI.HELP_Q2', answerKey: 'OCR.EUDI.HELP_A2' },
		{ id: 'Q3', questionKey: 'OCR.EUDI.HELP_Q3', answerKey: 'OCR.EUDI.HELP_A3' },
		{ id: 'Q4', questionKey: 'OCR.EUDI.HELP_Q4', answerKey: 'OCR.EUDI.HELP_A4' },
	];
}
